import type { MouseEvent, PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';
import { classes } from './utils';

export interface TextLinkProps extends PropsWithChildren {
  className?: string;
  size?: 'default' | 'sm';
  onClick?: (e: MouseEvent<HTMLButtonElement>) => void;
}

export default function TextLink({
  className,
  size = 'default',
  onClick,
  children,
}: TextLinkProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={twMerge(classes.link, classes[size], className)}>
      {children}
    </button>
  );
}
